module.exports = __webpack_public_path__ + "img/img_32389_0_456.6ab40400.png";